<template>
  <div>
    <div
      class="relative flex items-center transition-colors ease-out duration-200 font-bold md:text-blue md:bg-transparent py-2 pl-3 pr-3 md:pr-0 md:pl-0 md:py-0 text-base md:text-xl cursor-pointer md:cursor-auto"
      :class="{
        'text-white bg-blue': isOpen,
        'text-blue bg-gray': !isOpen
      }"
      @click="isOpen = !isOpen"
    >
      <span
        class="number w-6 h-6 md:w-8 md:h-8 transition-colors ease-out duration-200 rounded-full mr-3 md:mr-2"
      >
        <img
          :src="require(`../assets/numbers/${number}_32x32.png`)"
          alt="Number"
        />
      </span>
      {{ title }}

      <div class="md:hidden ml-auto">
        <div>
          <MinusIcon v-if="isOpen" />
          <PlusIcon v-else />
        </div>
      </div>
    </div>
    <div
      class="flex flex-wrap -mx-3 mt-3 collapse"
      :class="{ 'is-open': isOpen }"
    >
      <div class="px-3 w-full md:w-1/2 mb-5 mg:mb-0">
        <img class="block" :src="image" alt="" />
      </div>
      <div class="px-3 w-full md:w-1/2">
        <div class="flex flex-wrap items-center mb-4 text-center md:text-left">
          <div class="mx-auto mb-5 md:mb-0 md:ml-0 md:mr-4 w-16 h-16">
            <img
              :src="portrait"
              alt=""
              class="rounded-full border-2 border-gray-dark"
            />
          </div>
          <div class="leading-snug w-full md:w-auto">
            {{ name }}
          </div>
        </div>
        <p class="text-center md:text-left">
          {{ copy }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { MinusIcon, PlusIcon } from 'vue-feather-icons';
import { getPortrait } from '../utils/getMeta';

export default {
  components: {
    MinusIcon,
    PlusIcon
  },

  props: {
    number: {
      type: Number,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    copy: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    portrait() {
      return getPortrait(this.email);
    }
  }
};
</script>

<style lang="scss" scoped>
.number {
  line-height: 1.2;
}

.collapse {
  display: none;

  &.is-open {
    display: flex;
  }

  @screen md {
    display: flex;
  }
}
</style>
